var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStickIcFourthBgSnow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1074 0C35.8921 0 34.0962 1.79589 34.0962 4.01123V28.4228L16.8345 11.1612C15.2681 9.59471 12.7283 9.5947 11.1618 11.1612C9.59532 12.7277 9.59532 15.2674 11.1618 16.8339L28.4226 34.0947H4.01123C1.79589 34.0947 9.67993e-08 35.8906 0 38.106C-9.68575e-08 40.3213 1.79589 42.1172 4.01123 42.1172H28.4229L11.1607 59.3793C9.59422 60.9458 9.59422 63.4856 11.1607 65.0521C12.7272 66.6186 15.267 66.6186 16.8334 65.0521L34.0962 47.7893V72.2021C34.0962 74.4175 35.8921 76.2134 38.1074 76.2134C40.3228 76.2134 42.1187 74.4175 42.1187 72.2021V47.7908L59.3801 65.0522C60.9465 66.6187 63.4863 66.6187 65.0528 65.0522C66.6193 63.4857 66.6193 60.9459 65.0528 59.3795L47.7905 42.1172H72.2021C74.4175 42.1172 76.2134 40.3213 76.2134 38.106C76.2134 35.8906 74.4175 34.0947 72.2021 34.0947H47.7908L65.0517 16.8338C66.6182 15.2673 66.6182 12.7276 65.0517 11.1611C63.4852 9.59459 60.9454 9.59459 59.379 11.1611L42.1187 28.4214V4.01123C42.1187 1.79589 40.3228 0 38.1074 0Z",
    fill: "#727272",
    fillOpacity: 0.33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickIcFourthBgSnow);
export default __webpack_public_path__ + "static/media/stick-ic-fourth-bg-snow.769114ce798f85bbba5fabb29a36ad4d.svg";
export { ForwardRef as ReactComponent };